import { Route, Routes } from "react-router-dom";

// Page imports
import CreateClaim from "../pages/claim/view/CreateClaim";
import Claim from "../pages/claim/view/index";
import UpdateClaim from "../pages/claim/view/UpdateClaim";
import Dashboard from "../pages/dashboard/view/index";
import FileCreate from "../pages/files/view/CreateFile";
import FilesDetails from "../pages/files/view/FileInfo";
import Files from "../pages/files/view/index";
import FileStatus from "../pages/files/view/StatusFile";
import FileUpdate from "../pages/files/view/UpdateFile";
import LeaveCreate from "../pages/leave/view/CreateLeave";
import Leave from "../pages/leave/view/index";
import LeaveUpdate from "../pages/leave/view/UpdateLeave";
import NotFoundPage from "../pages/notFoundPage/notFoundPage";
import PayslipCreate from "../pages/payslip/view/CreatePayslip";
import Payslip from "../pages/payslip/view/index";
import PayslipUpdate from "../pages/payslip/view/UpdatePayslip";
import UserCreate from "../pages/user/view/CreateUser";
import UserManagement from "../pages/user/view/index";
import UserUpdate from "../pages/user/view/UpdateUser";
import { getUser } from "../services/auth";

// Route configurations
const adminRoutes = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/users",
    element: <UserManagement />,
  },
  {
    path: "/users/new",
    element: <UserCreate />,
  },
  {
    path: "/users/:id",
    element: <UserUpdate />,
  },
  {
    path: "/files",
    element: <Files />,
  },
  {
    path: "/files/new",
    element: <FileCreate />,
  },
  {
    path: "/files/:id",
    element: <FilesDetails />,
  },
  {
    path: "/files/:id/edit",
    element: <FileUpdate />,
  },
  {
    path: "/files/:id/status",
    element: <FileStatus />,
  },
  {
    path: "/leaves",
    element: <Leave />,
  },
  {
    path: "/leaves/apply",
    element: <LeaveCreate />,
  },
  {
    path: "/leaves/:id/edit",
    element: <LeaveUpdate />,
  },
  {
    path: "/claims",
    element: <Claim />,
  },
  {
    path: "/claims/new",
    element: <CreateClaim />,
  },
  {
    path: "/claims/:id/edit",
    element: <UpdateClaim />,
  },
  {
    path: "/payslips",
    element: <Payslip />,
  },
  {
    path: "/payslips/new",
    element: <PayslipCreate />,
  },
  {
    path: "/payslips/:id/edit",
    element: <PayslipUpdate />,
  },
];

const internalRoutes = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/users/:id",
    element: <UserUpdate />,
  },
  {
    path: "/files",
    element: <Files />,
  },
  {
    path: "/files/new",
    element: <FileCreate />,
  },
  {
    path: "/files/:id",
    element: <FilesDetails />,
  },
  {
    path: "/files/:id/edit",
    element: <FileUpdate />,
  },
  {
    path: "/files/:id/status",
    element: <FileStatus />,
  },
  {
    path: "/leaves",
    element: <Leave />,
  },
  {
    path: "/leaves/apply",
    element: <LeaveCreate />,
  },
  {
    path: "/leaves/:id/edit",
    element: <LeaveUpdate />,
  },
  {
    path: "/claims",
    element: <Claim />,
  },
  {
    path: "/claims/new",
    element: <CreateClaim />,
  },
  {
    path: "/claims/:id/edit",
    element: <UpdateClaim />,
  },
  {
    path: "/payslips",
    element: <Payslip />,
  },
  {
    path: "/payslips/new",
    element: <PayslipCreate />,
  },
  {
    path: "/payslips/:id/edit",
    element: <PayslipUpdate />,
  },
];

const externalRoutes = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/users/:id",
    element: <UserUpdate />,
  },
  {
    path: "/files",
    element: <Files />,
  },
  {
    path: "/files/:id",
    element: <FilesDetails />,
  },
  {
    path: "/files/:id/status",
    element: <FileStatus />,
  },
];

export default function RouteList() {
  const user = getUser();
  const userRole = user.role;
  const getRoutesByRole = (role: string) => {
    switch (role) {
      case "admin":
        return adminRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ));
      case "branchAdmin":
        return internalRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ));
      case "lawyer":
        return internalRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ));
      case "staff":
        return internalRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ));
      case "client":
        return externalRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ));
      case "agent":
        return externalRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ));
      default:
        return <Route path="*" element={<NotFoundPage />} />;
    }
  };

  return <Routes>{getRoutesByRole(userRole)}</Routes>;
}
